import './dist/vue-beatiful-chat.css'
import VueBeatifulChat from './dist/vue3-beautiful-chat.umd.js'

export default VueBeatifulChat
